module.exports = __webpack_public_path__ + "img/DataSecurity.b2ff12f1.svg";